import type { StorageFrontend, GdprCategory, ReadResult, BaseStorageFrontend } from "./storage/GdprStorage";

function enhanceWithReadFunction(storeFrontend: BaseStorageFrontend): StorageFrontend {
	return {
		get: storeFrontend.get,
		put: storeFrontend.put,
		remove: storeFrontend.remove,
		read: function (name: string): string | null | undefined {
			return this.get(name).actualResult;
		},
	};
}

/**
 * Delegates to another storage and prefixes all keys with the given prefix.
 * The other storage must provide the functions "get" and "put".
 */
export const PrefixedStorage = function (prefix: string, baseStore: StorageFrontend): StorageFrontend {
	if (typeof prefix !== "string" || prefix === "") {
		throw new Error("PrefixedStorage: Must provide a non empty prefix of type string, but was '" + prefix + "'");
	}

	if (!baseStore || !baseStore.put || !baseStore.get) {
		throw new Error("PrefixedStorage: baseStore must provide put and get functions");
	}

	const _get = function (key: string): ReadResult {
		return baseStore.get(prefix + key);
	};

	const _put = function (
		key,
		value,
		category: GdprCategory,
		optCookieOptions: Record<string, any> | null | undefined,
	): boolean {
		return baseStore.put(prefix + key, value, category, optCookieOptions);
	};

	const _remove = function (key): boolean {
		return baseStore.remove(prefix + key);
	};

	const result: BaseStorageFrontend = {
		get: _get,
		put: _put,
		remove: _remove,
	};
	return enhanceWithReadFunction(result);
};
